import { useEffect, useRef } from 'react';
import { gql, useMutation, useQuery } from '@apollo/client';
const EDITORS = gql`query CandidateToolEditors($component: String!) { candidateToolEditors(component: $component) { username page entityId fieldName } }`;
const PRESENCE = gql`mutation SetCandidateToolPresence($component: String!, $page: Int, $entityId: Int, $fieldName: String) { setCandidateToolPresence(component: $component, page: $page, entityId: $entityId, fieldName: $fieldName) { success } }`;
type Editor = { username: string; page: number; entityId: number; fieldName?: string };
export const useToolEditingPresence = (component: string, enabled: boolean, page: number, entityId: number | null, fieldName?: string | null) => {
  const { data, error } = useQuery<{ candidateToolEditors: Editor[] }>(EDITORS, { variables: { component }, skip: !enabled, pollInterval: enabled ? 30000 : 0, fetchPolicy: 'network-only' });
  const [update, state] = useMutation(PRESENCE);
  const currentPage = useRef(page);
  currentPage.current = page;
  useEffect(() => {
    if (!enabled) return;
    void update({ variables: { component, page, entityId, fieldName: fieldName || null } }).catch(() => undefined);
  }, [component, enabled, page, entityId, fieldName, update]);
  useEffect(() => () => {
    if (!enabled) return;
    void update({ variables: { component, page: currentPage.current, entityId: null, fieldName: null } }).catch(() => undefined);
  }, [component, enabled, update]);
  return { editors: data?.candidateToolEditors || [], error: error || state.error };
};
